'use client'

import Link from 'next/link'

import { useTranslation } from '@/hooks/client/use-translation'
import type { DirectoryRow } from '@/lib/directory/row'

import { CompareButton } from './compare-button'
import { RowListenButton } from './row-listen-button'
import { RowPrice } from './row-price'

interface RowFootProps {
  release: Pick<DirectoryRow, 'slug' | 'fullName' | 'fromPrice' | 'offer' | 'quietAudioUrl'>
  href: string
  isCompared: boolean
  atMax: boolean
  onToggleCompare: (slug: string) => void
}

// Price (the seller's offer, when there is one) on the left; review link, lab
// sample and the compare toggle on the right.
export const RowFoot = ({ release, href, isCompared, atMax, onToggleCompare }: RowFootProps) => {
  const { t } = useTranslation()

  return (
    <div className="border-navy/10 col-[1/4] row-start-3 flex flex-wrap items-center justify-between gap-x-2 gap-y-3 border-t pt-3 sm:gap-x-4 md:pt-4 laptop:col-[2/4] laptop:pt-3">
      <RowPrice release={release} />
      <div className="ml-auto flex shrink-0 items-center gap-2 sm:gap-4">
        <Link
          href={href}
          prefetch={false}
          data-tracking="ignore"
          className="text-lapis hover:text-navy hidden text-[14px] font-medium underline decoration-dotted underline-offset-4 sm:inline"
        >
          {t('directory.row.readReview', 'Read review')}
        </Link>
        {release.quietAudioUrl ? <RowListenButton url={release.quietAudioUrl} name={release.fullName} /> : null}
        <CompareButton
          selected={isCompared}
          disabled={!isCompared && atMax}
          name={release.fullName}
          onToggle={() => onToggleCompare(release.slug)}
        />
      </div>
    </div>
  )
}
